// src/routes.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import LoginPage from "./LoginPage";
import ErrorPage from "./ErrorPage";
import Scan from "./Scan";
import ScanResult from "./scanresult/ScanResult";
import ScanResultAdvanced from "./ScanResultAdvanced/ScanResultAdvanced";
import ProtectedRoute from "./ProtectedRoute";
import BaseLayout from "./BaseLayout";
import UnauthenticatedBaseLayout from "./UnauthenticatedBaseLayout";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/scan/error" element={<ErrorPage />} />
      <Route
        element={
          <ProtectedRoute>
            <BaseLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/scan" element={<Scan />} />
        <Route path="/scan-result/:uuid" element={<ScanResultAdvanced />} />
      </Route>
      <Route
        element={
          <UnauthenticatedBaseLayout />
        }
      >
        <Route path="/public/scan-result/:uuid" element={<ScanResultAdvanced />} />
      </Route>
      <Route path="*" element={<LoginPage />} />
    </Routes>
  );
}
